import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, FinalFormInput, FormContainer, FieldGroup } from '@utex/ui-kit';
import { AbroadBankWithdrawFiatDetails } from '@unitedtraders/utcom-api-sdk';
import { Layout } from '../../../components/Layout';
import { Instrument } from '../../../hooks/mapInstruments';
import { AmountInput } from '../../../components/AmountInput';
import { FormError } from '../../../components/FormError';
import { Commission } from '../Commission';
import { useFormProps } from './hooks';
import { SwiftInput } from '../SwiftInput';

export interface FormValues extends Required<AbroadBankWithdrawFiatDetails> {
  amount: number;
}

const dateMask = '99.99.9999'.split('').map((v) => (v !== '9' ? v : /\d/));

const ibanMask = Array(31).fill(/\d/);

export const AbroadBankForm: React.FC<Instrument> = (props) => {
  const { t } = useTranslation('toBank');
  const { validate, validateTips, onSubmit } = useFormProps(props);

  const { commission, currency } = props;

  return (
    <FormContainer<FormValues>
      onSubmit={onSubmit}
      validate={validate}
      validateTips={validateTips}
      render={({ handleSubmit, submitError, submitting }) => (
        <Layout.Form onSubmit={handleSubmit} noValidate>
          <Layout.FormContent>
            <Box display="flex" flexDirection="column">
              <AmountInput currency={currency} />
              <SwiftInput name="bankSwift" />
              <Box marginTop={10}>
                <FieldGroup>
                  <FinalFormInput
                    name="clientName"
                    id="clientName"
                    label={t('FIO of recipient')}
                    placeholder={t('As in the profile, in Latin letters')}
                  />
                  <FinalFormInput
                    name="birthday"
                    id="birthday"
                    label={t('Birthday')}
                    placeholder={t('DD-MM-YYYY')}
                    mask={dateMask}
                  />
                  <FinalFormInput
                    name="clientHomeAddress"
                    id="clientHomeAddress"
                    label={t('Home address')}
                    placeholder={t('Your complete address')}
                  />
                  <FinalFormInput
                    name="iban"
                    id="iban"
                    label={t('Bank account')}
                    placeholder={t('IBAN - 15 to 31 digits')}
                    mask={ibanMask}
                  />
                </FieldGroup>
              </Box>
            </Box>
          </Layout.FormContent>
          <FormError>{submitError}</FormError>

          <Layout.FormFooter>
            <Button view="alert" type="submit" isLoading={submitting}>
              {t('Continue')}
            </Button>
            <Commission>{commission}</Commission>
          </Layout.FormFooter>
        </Layout.Form>
      )}
    />
  );
};
